import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@sundkortid/ui';
import type { AuthTokens, SessionUser } from '@sundkortid/shared';
import { api, ApiRequestError } from '../../api/client';
import { useAuthStore } from '../../stores/auth';

const roleHome: Record<string, string> = {
  admin: '/admin',
  super_admin: '/admin',
  staff: '/staff',
  user: '/dashboard',
};

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      const tokens = await api.post<AuthTokens>('/auth/login', { email, password });
      useAuthStore.getState().setAccessToken(tokens.accessToken);
      const user = await api.get<SessionUser>('/users/me');
      useAuthStore.getState().setUser(user);
      useAuthStore.getState().setLoading(false);
      navigate(roleHome[user.role] ?? '/dashboard');
    } catch (err) {
      setError(err instanceof ApiRequestError ? err.message : 'Villa kom upp við innskráningu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-sm border border-gray-100 p-8">
        <Link to="/" className="flex justify-center mb-6">
          <img src="/logo.png" alt="Sundkortið" className="h-24 w-auto" />
        </Link>
        <h2 className="text-xl font-semibold text-gray-900 mb-6">Innskráning</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Netfang
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-300 focus:border-primary outline-none"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Lykilorð
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-300 focus:border-primary outline-none"
            />
          </div>

          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Augnablik…' : 'Skrá inn'}
          </Button>
        </form>

        <div className="mt-4 text-center text-sm text-gray-600">
          <Link to="/forgot-password" className="text-primary hover:underline">
            Gleymt lykilorð?
          </Link>
        </div>

        <div className="mt-6 text-center text-sm text-gray-600">
          Áttu ekki aðgang?{' '}
          <Link to="/register" className="text-primary font-medium hover:underline">
            Nýskráðu þig hér
          </Link>
        </div>
      </div>
    </div>
  );
}
